const sectorsSidebar = {
  sector: 'القطاع',
  selectedSectors: 'القطاعات المحددة',
  allSectors: 'جميع القطاعات',
};

export default sectorsSidebar;
